import { Type } from 'class-transformer'

import { BaseDelayType } from './BaseDelayType'
import { DelayDataLimitType, DelayType } from './types'

export class DelayIntervalType extends BaseDelayType {
  declare type: DelayType.Interval
  offset!: number
  @Type(() => DelayDataLimitType)
  limit!: DelayDataLimitType | null
}
